import { AlertTriangleIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  readonly title: string;
  readonly message: string;
  readonly onRetry: () => void;
  readonly retryLabel?: string;
}

/**
 * The "this screen could not load" card.
 *
 * Extracted because it had been copied verbatim into five screens, which is
 * five places for the wording, the role and the retry affordance to drift
 * apart. The message is rendered in mono: it is the API's own text, and
 * looking like a quotation is what stops it reading as our prose.
 */
export function ErrorState({ title, message, onRetry, retryLabel = 'Retry request' }: ErrorStateProps) {
  return (
    <section
      role="alert"
      className="flex flex-col items-center gap-3 rounded-xl border border-err-fg/25 bg-err-bg/40 px-8 py-12 text-center"
    >
      <AlertTriangleIcon aria-hidden="true" className="size-5 text-err-fg" />
      <h2 className="text-[15px] font-semibold text-foreground">{title}</h2>
      <p className="max-w-[460px] font-mono text-[13px] leading-relaxed text-muted-foreground">{message}</p>
      <Button variant="outline" onClick={onRetry} className="mt-1">
        {retryLabel}
      </Button>
    </section>
  );
}
